export default "__VITE_ASSET__bIxQGyZM__"